import './NaveBar.css';
import logo from '../../assets/images/logo.png';
import { Link } from 'react-scroll';
import { Component } from 'react';

class NaveBar extends Component {
    state = {
        clicked: false,
        scrolled: false
    };

    handleClick = () => {
        this.setState({ clicked: !this.state.clicked });
    };

    handleScroll = () => {
        if (window.scrollY > 0) {
            this.setState({ scrolled: true });
        } else {
            this.setState({ scrolled: false });
        }
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        return (
            <div>
                <nav className={this.state.scrolled ? 'navbar scrolled' : 'navbar'}>
                    <a href=""><img src={logo} alt="logo" /></a>
                    <div>
                        <ul id='menu_links' className={this.state.clicked ? 'active' : ''}>
                            <li><Link to="hero" smooth={true} duration={500}>Home</Link></li>
                            <li><Link to="about" smooth={true} duration={500}>About Us</Link></li>
                            <li><Link to="services" smooth={true} duration={500}>Services</Link></li>
                            <li><Link to="our-galaxy" smooth={true} duration={500}>Our Galaxy</Link></li>
                            <li><Link to="property_insights" smooth={true} duration={500}>Property Insights</Link></li>
                            <li><Link to="recent_purchases" smooth={true} duration={500}>Recent Purchases</Link></li>
                            <li><Link to="contact" smooth={true} duration={500}>Contact Us</Link></li>
                            <li className='btn'><a href="https://calendly.com/buyersgalaxy/30min?month=2024-11" target='_blank'>Book a Call</a></li>
                        </ul>
                    </div> 
                    <div id='mobile' onClick={this.handleClick}>
                        <i id='bar' className={this.state.clicked ? 'fas fa-times' : 'fas fa-bars'}></i>
                    </div>
                </nav>
            </div>
        );
    }
}

export default NaveBar;
